import { StaticDataState } from '../../types'

export const state: StaticDataState = {
  timeSlots: undefined,
  predefinedMeetingTypes: {
    isLoading: false,
    content: undefined
  }
}
